import { KeyConstructor } from './keyConstructor';
const SPACE_ROLES_KEY = 'spaceRoles';
export const getSpaceRolesKey = KeyConstructor(SPACE_ROLES_KEY);
//# sourceMappingURL=spaceRoles.key.js.map